import { CircularProgress, InputAdornment } from "@mui/material";
import React, { useCallback } from "react";
import { IconComponent, icon, CustomIconButton, CustomTextField } from "../..";
import styles from "./SearchInput.module.css";

const SearchInput = React.forwardRef(
	(
		{
			autoFocus = false,
			className = "",
			disabled = false,
			error = false,
			fullWidth = false,
			helperText = "",
			isLoading = false,
			label,
			onBlur,
			onChange,
			onClearSearch = null,
			onFocus,
			onKeyPress,
			onKeyDown,
			placeholder = "",
			required = false,
			size = "medium",
			value,
		},
		ref
	) => {
		const handleKeyDown = useCallback(
			(e) => {
				if (onKeyDown) {
					onKeyDown(e);
				}

				if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
					e.preventDefault();
					const textField = e.target;
					if (e.key === "ArrowLeft") {
						if (textField.selectionStart > 0) {
							textField.setSelectionRange(textField.selectionStart - 1, textField.selectionStart - 1);
						}
					} else if (e.key === "ArrowRight") {
						if (textField.selectionStart < textField.value.length) {
							textField.setSelectionRange(textField.selectionStart + 1, textField.selectionStart + 1);
						}
					}
				}
			},
			[onKeyDown]
		);

		return (
			<CustomTextField
				autoFocus={autoFocus}
				className={className}
				disabled={disabled}
				error={error}
				fullWidth={fullWidth}
				helperText={helperText}
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							{isLoading && <CircularProgress size={25} thickness={3} />}
							{!isLoading && (!onClearSearch || !value || value.length === 0) && (
								<IconComponent color="var(--grey-400)" icon={icon.faSearch} />
							)}
							{!isLoading && onClearSearch && value && value.length > 0 && (
								<CustomIconButton
									className={styles.cancelButton}
									icon={icon.faTimes}
									size="sm"
									onClick={onClearSearch}
								/>
							)}
						</InputAdornment>
					),
					style: {
						fontSize: "var(--font-size-sm)",
						height: 32,
					},
				}}
				inputRef={ref}
				placeholder={label || placeholder}
				required={required}
				size={size}
				value={value}
				variant="outlined"
				onBlur={onBlur}
				onChange={onChange}
				onFocus={onFocus}
				onKeyDown={handleKeyDown}
				onKeyPress={onKeyPress}
			/>
		);
	}
);
export default SearchInput;
